/**
 * The Gleap action "Open my account case" (TAG-4088): opens the signed-in
 * merchant's case page on the TagadaPay dashboard in a new tab. The short link
 * names the account only; the dashboard resolves it to the case, or to the
 * application when the account has no TPA.
 *
 * The SDK has no API for the widget's menu. The item is configured in Gleap's
 * admin, as a menu item whose action is "custom action" with exactly
 * CASE_LINK_ACTION_NAME as its name. This file only answers it.
 */

export const CASE_LINK_ACTION_NAME = 'open-account-case'

const DASHBOARD_ORIGIN = 'https://dashboard.tagadapay.io'

export function caseLinkUrl(accountId: string): string {
	return `${DASHBOARD_ORIGIN}/case/${encodeURIComponent(accountId)}`
}

type CustomActionHandler = (action: { name: string }) => void

/**
 * Register once: the SDK keeps every handler it is given. The account is read
 * at click time because it loads after Gleap initialises. Nothing opens while
 * it is unknown.
 */
export function registerCaseLinkAction(
	register: (handler: CustomActionHandler) => void,
	getAccountId: () => string | undefined,
	openInNewTab: (url: string) => void,
): void {
	register(({ name }) => {
		if (name !== CASE_LINK_ACTION_NAME) return
		const accountId = getAccountId()
		if (accountId) openInNewTab(caseLinkUrl(accountId))
	})
}
